import React, { useEffect, useState } from "react";
import { Dots, Spinner } from "react-activity";
import * as url from "../../helpers/url_helper";
import { connect } from "react-redux";
import Select from "react-select";
import { setBreadcrumbItems } from "../../store/actions";
import { useNavigate, useParams } from "react-router-dom";
import Spinners from "components/Common/Spinner";
import "flatpickr/dist/themes/material_blue.css";
import { Input } from "reactstrap";
import { toast } from "react-toastify";
import "../../assets/css/social_media.css";

const object = {
  loading: false,
  errors: {},
  ResErrors: {},
  isRedirect: false,
  sangathanId: null,
  assignRole: "",
  status: "true",
  name: "",
  place_id: "",
  optionalFieldAllow: null,
  selectedLocation: "",
  addressComponent: null,
  Locations: [],
  id: "",
  defaultAddress: "",
  countries: [],
  stateList: [],
  districtList: [],
  CityList: [],
  selectedCity: "",
  selectedCountry: "",
  selectedDistrict: "",
  selectedState: "",
  country: "",
  state: "",
  district: "",
  city: "",
  countryDataCode: "",
  stateCode: "",
  districtCode: "",
  cityCode: "",
  otherLinks: [],
};

const LocationAdd = (props) => {
  document.title = "Manage Location - VUF";
  const { id } = useParams();
  const navigate = useNavigate();
  const [countries, setcountries] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [districtList, setdistrictList] = useState([]);
  const [cityList, setcityList] = useState([]);
  const [Locations, setLocations] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [selectedCity, setselectedCity] = useState({});
  const [selectedCountry, setselectedCountry] = useState({});
  const [selectedDistrict, setselectedDistrict] = useState({});
  const [selectedState, setselectedState] = useState({});
  const [selectedPlatform, setPlatform] = useState();
  const [platformUrl, setPlatformUrl] = useState();
  const [links, setLinks] = useState([]);
  const [state, setState] = useState(object);

  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Manage Location", link: "#" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems("Manage Location", breadcrumbItems);
  });
  useEffect(() => {
    if (id !== "" && id != null && id != undefined) {
      getLocation();
    } else {
      onGetCountryList();
    }
  }, []);

  const handleInputChange = (index, field, value) => {
    // Use the functional update to ensure 'prev' is not undefined
    setLinks((prev) => {
      if (!prev) return [{ platform: "", url: "" }]; // Safety check

      const updatedLinks = [...prev];

      // Ensure the object at this index exists before assigning
      if (updatedLinks[index]) {
        updatedLinks[index] = {
          ...updatedLinks[index],
          [field]: value,
        };
      }

      // Sync with your main 'state' object
      setState((prevState) => ({
        ...prevState,
        otherLinks: updatedLinks,
      }));

      return updatedLinks;
    });
  };
  const addRow = () => {
    setLinks([...links, { platform: "", url: "" }]);
  };
  const removeRow = (id, index) => {
    // Filter by index to ensure the correct row is removed from the UI
    const newLinks = links.filter((_, i) => i !== index);

    // Update the local array state
    setLinks(newLinks);

    // CRITICAL: Update the main 'state' object so the Payload is correct
    setState((prevState) => ({
      ...prevState,
      otherLinks: newLinks,
    }));
  };

  /**
   *
   * @param null
   * @description This function validate inputs
   * @returns boolean
   */
  function handleValidation() {
    let errors = {};
    let formIsValid = true;

    if (state.name?.trim() === "") {
      formIsValid = false;
      errors.name = "Please enter event Name";
    }
    setState((prevState) => ({
      ...prevState,
      errors: errors,
    }));

    return formIsValid;
  }
  function getLocation() {
    setLoading(true);
    let urlPath = "location/GetLocationDetails/" + id;
    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          var dataRes = responseData.data;
          setState((prevState) => ({
            ...prevState, // Copy the existing state
            id: id,
            eventName: dataRes.name,
            name: dataRes.name,
            place_id: dataRes.place_id,
            status: dataRes.status,
            optionalFieldAllow: dataRes.optionalFieldAllow,
            country: dataRes.country,
            state: dataRes.state,
            district: dataRes.district,
            city: dataRes.city,
            selectedCountry: dataRes.country,
            selectedState: dataRes.state,
            selectedDistrict: dataRes.district,
            selectedCity: dataRes.city,
            countryDataCode: dataRes.countryDataCode,
            stateCode: dataRes.stateCode,
            districtCode: dataRes.districtCode,
            cityCode: dataRes.cityCode,
            addressComponent: dataRes.addressComponent,
            otherLinks: dataRes.otherLinks,
          }));
          setLinks(
            dataRes.otherLinks && dataRes.otherLinks.length > 0
              ? dataRes.otherLinks
              : [{ platform: "", url: "" }],
          );
          setselectedCountry({ label: dataRes.country, value: 0 });
          setselectedState({ label: dataRes.state, value: 0 });
          setselectedDistrict({ label: dataRes.district, value: 0 });
          setselectedCity({ label: dataRes.city, value: 0 });

          onGetCountryList();
        } else {
          alert("Something went wrong, Please try again after sometime.");
          // this.setState({ loading: false });
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        alert("Something went wrong, Please try again after sometime.");
        // this.setState({ loading: false });
      })
      .finally((final) => {
        // return this.setState({ isInvitingUser: false })
      });
  }
  function onGetCountryList() {
    let urlPath = "auth/CountryList";

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          var data = responseData.response;

          let countries = [];
          countries.push({ label: "--Select--", value: "" });
          data.map((c, i) => {
            if (
              selectedCountry.label == c.country_name &&
              selectedCountry.value == 0
            ) {
              setselectedCountry({ ...c, label: c.country_name, value: c.id });
              onGetStateList(c.id);
            }
            countries.push({ ...c, label: c.country_name, value: c.id });
          });
          const cot = [{ options: countries }];
          setcountries(cot);

          setLoading(false);
        }
      })
      .catch((error) => {
        // // console.log("err", error);
      })
      .finally((final) => {});
  }
  function onGetStateList(data) {
    setState((prevState) => ({
      ...prevState, // Copy the existing state
      countryDataCode: data,
    }));
    if (data != null && data != undefined && data != "") {
      let urlPath = "auth/StatesList/" + data;

      fetch(url.VUF_APP_API + urlPath, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        // body: Body,
      })
        .then((response) => response.json())
        .then(async (responseData) => {
          // // // console.log("RES ",responseData)
          if (responseData.status) {
            var data = responseData.response;
            let stateList = [];
            stateList.push({ label: "--Select--", value: "" });
            data.map((c, i) => {
              if (
                selectedState.label == c.state_title &&
                selectedState.value == 0
              ) {
                setselectedState({
                  ...c,
                  label: c.state_title,
                  value: c.state_id,
                });
                onGetDistrictList(c.state_id);
              }
              stateList.push({ ...c, label: c.state_title, value: c.state_id });
            });
            const cot = [{ options: stateList }];
            setStateList(cot);
            // stateList.map((c)=>{
            //     if(state.state==c.label){
            //         setselectedState(c)
            //         onGetDistrictList(c.value)
            //     }
            // })
          }
        })
        .catch((error) => {
          // // console.log("err", error);
        })
        .finally((final) => {});
    }
  }
  function onGetDistrictList(data) {
    setState((prevState) => ({
      ...prevState, // Copy the existing state
      stateCode: data,
    }));

    let urlPath = "auth/DistrictsList/" + data;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        // // // console.log("RES ",responseData)
        if (responseData.status) {
          var data = responseData.response;
          let districtList = [];
          districtList.push({ label: "--Select--", value: "" });
          data.map((c, i) => {
            if (
              selectedDistrict.label == c.district_title &&
              selectedDistrict.value == 0
            ) {
              setselectedDistrict({
                ...c,
                label: c.district_title,
                value: c.districtid,
              });
              onGetCitiesList(c.districtid);
            }
            districtList.push({ label: c.district_title, value: c.districtid });
          });

          const cot = [{ options: districtList }];
          setdistrictList(cot);

          // districtList.map((c)=>{
          //     if(state.district==c.label){
          //         setselectedDistrict(c)
          //         onGetCitiesList(c.value)
          //     }
          // })
        }
      })
      .catch((error) => {
        // // console.log("err", error);
      })
      .finally((final) => {});
  }
  function onGetCitiesList(data) {
    setState((prevState) => ({
      ...prevState, // Copy the existing state
      districtCode: data, // Update only the `districtCode` property
    }));
    let urlPath = "auth/CitiesList/" + data;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        // // // console.log("RES ",responseData)
        if (responseData.status) {
          var data = responseData.response;
          let cityList = [];
          cityList.push({ label: "--Select--", value: "" });
          data.map((c, i) => {
            if (selectedCity.label == c.name && selectedCity.value == 0) {
              setselectedCity({ ...c, label: c.name, value: c.id });
            }
            cityList.push({ label: c.name, value: c.id });
          });

          const cot = [{ options: cityList }];
          setcityList(cot);

          // cityList.map((c)=>{
          //     if(state.city==c.label){
          //         setselectedCity(c)
          //     }
          // })
        }
      })
      .catch((error) => {
        // // console.log("err", error);
      })
      .finally((final) => {});
  }

  function onHandleLocation(e) {
    const token = localStorage.getItem("token");
    // if (!handleValidation()) {
    //   return false;
    // }
    // const { state, signOut } = this.context;
    // await this.setState({ isInvitingUser: true })
    const Body = JSON.stringify({
      name: state.name,
      place_id: state.place_id,
      status: state.status,
      optionalFieldAllow: state.optionalFieldAllow,
      addressComponent: state.addressComponent,
      country: selectedCountry.label,
      state: selectedState.label,
      district: selectedDistrict.label,
      city: selectedCity.label,
      countryDataCode: state.countryDataCode,
      stateCode: state.stateCode,
      districtCode: state.districtCode,
      cityCode: state.cityCode,
      otherLinks: state.otherLinks ? state.otherLinks : [],
      _id: id,
    });
    // console.log(Body)
    // return;
    setLoading(true);
    let urlPath = "location/create-location";
    fetch(url.VUF_APP_API + urlPath, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status && "response" in responseData) {
          if (id == null || id == "" || id == undefined) {
            toast.success("Location Successfully Added.");
          } else {
            toast.success("Location Successfully Updated.");
          }

          navigate("/LocationList");
          // this.redirectWithPath("/LocationList")
        } else if (!responseData.status && "auth" in responseData) {
          // AuthController.Logout();
        } else if (!responseData.status && responseData.error) {
          toast.error(responseData?.error || "Error");
        } else {
          toast.error("Something went wrong, Please try again after sometime.");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        toast.error("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {
        // return this.setState({ loading: false })
      });
  }

  return (
    <div className="container my-4" style={{ maxWidth: "100%" }}>
      <div className="card shadow border-0 rounded-4">
        <div className="card-body p-4">
          {/* Title */}
          <h4 className="fw-semibold mb-4">{id ? "Update Location" : "Add Location"}</h4>

          {/* Name + Optional Field */}
          <div className="row align-items-center mb-4">
            <div className="col-md-6">
              <label className="form-label fw-semibold">Name</label>
              <Input
                type="text"
                className="form-control form-control-lg"
                name="name"
                placeholder="Enter name"
                onChange={(event) => {
                  setState((prevState) => ({
                    ...prevState,
                    name: event.target.value,
                  }));
                }}
                value={state.name}
              />
            </div>
            <div className="col-md-3">
              <label className="form-label fw-semibold">Country / દેશ:</label>
              <Select
                value={selectedCountry}
                onChange={(e) => {
                  setselectedCountry(e);
                  setselectedDistrict({
                    label: "--Select--",
                    value: "",
                  });
                  setselectedCity({
                    label: "--Select--",
                    value: "",
                  });
                  setselectedState({
                    label: "--Select--",
                    value: "",
                  });
                  onGetStateList(e.value);
                }}
                options={countries}
              ></Select>
            </div>

            <div className="col-md-3">
              <label className="form-label fw-semibold">State / રાજ્ય:</label>
              <Select
                classNamePrefix="select2-selection"
                value={selectedState}
                onChange={(e) => {
                  setselectedState(e);
                  setselectedDistrict({
                    label: "--Select--",
                    value: "",
                  });
                  setselectedCity({
                    label: "--Select--",
                    value: "",
                  });
                  onGetDistrictList(e.value);
                }}
                options={stateList}
              />
            </div>
          </div>

          {/* Dropdown Section */}
          <div className="row g-4">
            <div className="col-md-6">
              <label className="form-label fw-semibold">
                District / જિલ્લો:
              </label>
              <Select
                classNamePrefix="select2-selection"
                value={selectedDistrict}
                onChange={(e) => {
                  setselectedDistrict(e);
                  setselectedCity({
                    label: "--Select--",
                    value: "",
                  });
                  onGetCitiesList(e.value);
                }}
                options={districtList}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">City / શહેર:</label>
              <Select
                classNamePrefix="select2-selection"
                value={selectedCity}
                onChange={(e) => {
                  setselectedCity(e);
                }}
                options={cityList}
              />
            </div>
          </div>
          <div className="row g-4 mt-1">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="mb-0">Social Media Links</h4>
              <button
                className="btn btn-primary rounded-pill px-3"
                onClick={addRow}
              >
                <i className="fas fa fa-plus me-1"></i>Link
              </button>
            </div>
            {links?.map((link, index) => (
              <div
                key={link?._id || index}
                className="row align-items-end social-link-row"
              >
                {/* Platform Select */}
                <div className="col-md-4">
                  <label className="form-label small fw-bold text-secondary">
                    Platform
                  </label>
                  <Select
                    classNamePrefix="select2-selection"
                    value={
                      link?.platform
                        ? { label: link.platform, value: link.platform }
                        : null
                    }
                    onChange={(e) =>
                      handleInputChange(index, "platform", e?.value)
                    }
                    options={[
                      { label: "Instagram", value: "Instagram" },
                      { label: "Facebook", value: "Facebook" },
                      { label: "LinkedIn", value: "LinkedIn" },
                      { label: "Youtube", value: "Youtube" },
                      { label: "Others", value: "Others" },
                    ]}
                  />
                </div>

                {/* URL Input */}
                <div className="col-md-7">
                  <label className="form-label small fw-bold text-secondary">
                    Platform URL
                  </label>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-end-0">
                      <i className="bi bi-link-45deg"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder=""
                      value={link?.url || ""}
                      onChange={(e) =>
                        handleInputChange(index, "url", e.target.value)
                      }
                    />
                  </div>
                </div>

                {/* Remove Button */}
                <div className="col-md-1 text-end">
                  <button
                    className="btn btn-danger border-0 btn-remove"
                    onClick={() => removeRow(link?._id, index)}
                    disabled={links.length === 1}
                  >
                    <i className="fas fa fa-trash"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
          {/* Second Row City */}
          {/* <div className="row mt-3">
            <div className="col-md-6 mt-4 mt-md-0 d-flex align-items-center">
              <input
                className="form-check-input me-2"
                type="checkbox"
                name="OptionalField"
                onChange={(event) => {
                  state.optionalFieldAllow == true
                    ? setState((prevState) => ({
                        ...prevState,
                        optionalFieldAllow: false,
                      }))
                    : setState((prevState) => ({
                        ...prevState,
                        optionalFieldAllow: true,
                      }));
                }}
                value={state.optionalFieldAllow}
                defaultChecked={state.optionalFieldAllow}
              />
              <label
                className="form-check-label fw-semibold"
                htmlFor="optionalCheck"
              >
                Optional Field Allow
              </label>
            </div>
          </div> */}

          <div className="mt-4">
            <button
              type="button"
              className="btn btn-outline-primary px-4"
              onClick={(event) => onHandleLocation(event)}
            >
              {id ? "Update Location" : "Add Location"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(LocationAdd);
